import { ChevronRight, Mail, Shield, FileText } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import Card from '@/components/ui/Card';

const SUPPORT_EMAIL = 'support@citizenly.net';
const PRIVACY_PATH = '/privacy';
const TERMS_PATH = '/terms';

interface RowProps {
  icon: LucideIcon;
  label: string;
  to: string;
  external?: boolean;
}

function Row({ icon: Icon, label, to, external }: RowProps) {
  const className =
    'flex items-center gap-4 py-3 group cursor-pointer';
  const content = (
    <>
      <div className="w-9 h-9 rounded-full bg-primary-light flex items-center justify-center flex-shrink-0">
        <Icon size={18} className="text-primary" />
      </div>
      <span className="flex-1 font-sans font-medium text-base text-text-primary group-hover:text-primary transition-colors">
        {label}
      </span>
      <ChevronRight
        size={18}
        className="text-text-muted group-hover:text-primary transition-colors"
      />
    </>
  );

  if (external) {
    return (
      <a href={to} className={className}>
        {content}
      </a>
    );
  }
  return (
    <Link to={to} className={className}>
      {content}
    </Link>
  );
}

export default function HelpAndLegalCard() {
  return (
    <Card>
      <p className="font-display font-semibold text-lg text-text-primary leading-tight mb-1">
        Help &amp; legal
      </p>
      <div className="divide-y divide-border">
        <Row
          icon={Mail}
          label="Contact support"
          to={`mailto:${SUPPORT_EMAIL}`}
          external
        />
        <Row icon={Shield} label="Privacy Policy" to={PRIVACY_PATH} />
        <Row icon={FileText} label="Terms of Service" to={TERMS_PATH} />
      </div>
    </Card>
  );
}
